import React, {useState} from "react";
import {useOnBoarderStyle} from "../styles/OnBoarderSlideStyles";
import clsx from 'clsx';
import {Typography, Button, Container, useMediaQuery} from "@material-ui/core";
import {useTheme} from '@material-ui/core/styles';
import {Redirect} from "react-router-dom";
import Routes from "../constants/Routes";
import {OperationStatus} from "../enums/OperationStatus";
import {useCookies} from "react-cookie";
import {Constants} from "../constants/Constants";
import {useSelector, RootStateOrAny} from "react-redux";
import {LoginState} from '../enums/AuthState';

const ThirdIntro = React.forwardRef(function (props: any) {

    const thirdIntroClasses = useOnBoarderStyle();
    const componentHeight = props.height;
    const componentWidth = props.width;
    const mobileMode: boolean = props.mode;
    const smallButtonMode = props.buttonMode;
    const theme = useTheme();
    const extremelySmallViewPort = useMediaQuery(theme.breakpoints.down(360));
    const fixedVH = useMediaQuery(theme.breakpoints.down(299));

    const [navigateToLogin, setNavigateToLogin] = useState(false);
    const [, setCookie] = useCookies([Constants.ACTIVE_OPERATION_STATUS]);
    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    const initAuth = () => {
        setCookie(Constants.ACTIVE_OPERATION_STATUS, OperationStatus.MULTIPLY_BTC)
        setNavigateToLogin(true);
    }

    return (
        <div className={clsx(thirdIntroClasses.thirdIntro)}
             style={{
                 height: componentHeight,
                 width: componentWidth ?? '100%',
                 overflowY: fixedVH ? 'hidden' : 'auto'
             }}>
            <Container maxWidth="sm"
                       style={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                           justifyContent: 'center',
                           zIndex: 1,
                       }}>
                <Typography variant="h1" className={thirdIntroClasses.onboarderMsg1}
                            dangerouslySetInnerHTML={{__html: `Multiply BTC`}}
                            style={{
                                marginTop: mobileMode ? componentHeight * 0.2 : componentHeight * 0.1,
                            }}/>
                <img src={require('../images/multiply_btc.png')} alt={"Multiply BTC"}/>
                <Typography variant="h3" className={thirdIntroClasses.onboaderMsg2}
                            dangerouslySetInnerHTML={{__html: `<span style='font-size:${extremelySmallViewPort ? 19 : 23}px'>Multiply your bitcoins by up to <b style='color:white;'>4,750</b> playing a simple <b style='color:white;'>${Constants.MULTIPLY_BTC_GAME}</b> game that has been designed to be <b style='color:white;'>provably fair</b>.</span>`}}/>
                <Button disabled={logInState === LoginState.STARTED} onClick={initAuth}
                        className={smallButtonMode ? thirdIntroClasses.multiplyBTCBtnSmall : thirdIntroClasses.multiplyBTCBtn}>Play
                    Now</Button>
            </Container>
            {
                navigateToLogin &&
                <Redirect to={Routes.LOGIN}/>
            }
        </div>
    );
});

export default ThirdIntro;